document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-auto-scroll-section]").forEach((section) => {
    const enableAutoScroll = section.dataset.enableAutoScroll === "true";
    if (!enableAutoScroll) return;

    let isScrolling = false;
    let touchStartY = 0;

    const scrollToNext = () => {
      if (isScrolling) return;
      isScrolling = true;
      window.scrollTo({
        top: section.offsetTop + section.offsetHeight,
        behavior: "smooth",
      });
      setTimeout(() => (isScrolling = false), 700);
    };

    const scrollToTop = () => {
      if (isScrolling) return;
      isScrolling = true;
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
      setTimeout(() => (isScrolling = false), 700);
    };

    // Eventos touch
    section.addEventListener(
      "touchstart",
      (e) => (touchStartY = e.touches[0].clientY)
    );

    section.addEventListener(
      "touchmove",
      (e) => {
        if (isScrolling) return;
        const touchEndY = e.touches[0].clientY;
        const deltaY = touchStartY - touchEndY;

        if (deltaY > 50) scrollToNext();
        if (deltaY < -50) scrollToTop();
        e.preventDefault();
      },
      { passive: false }
    );

    // Eventos wheel
    section.addEventListener(
      "wheel",
      (e) => {
        if (isScrolling) return;
        e.deltaY > 0 ? scrollToNext() : scrollToTop();
        e.preventDefault();
      },
      { passive: false }
    );
  });
});
